<div class="flex flex-col">
<!--  {{ regionService.selectedRegion$() }}-->
<!--  {{ selectedRegionId$() }}-->
  <select class="select-default" [value]="selectedRegionId$()" (change)="handleRegionChange($event)">
    @if (allowNoSelection) {
      <option value="" disabled [selected]="!selectedRegionId$()">
        {{ 'Select a Region' }}
      </option>
    }

    @for (region of regionService.supportedRegions; track region) {
      <option [value]="region.id" [selected]="selectedRegionId$() === region.id">
        {{ region.displayName }}
      </option>
    }
  </select>
</div>
